import axios from '@/lib/axios';
import { useQuery } from '@tanstack/react-query';
import { PaymentTaskComment } from '@/hooks/api/models';
import queryClient from '@/lib/queryClient';

/**
 * 1110. 支払タスクコメント一覧
 * [GET] /workspaces/:identifier/teams/:team_id/purchase_orders/:purchase_order_id/payment_tasks/:payment_task_id/payment_task_comments
 */
type Props = {
  identifier: string;
  team_id: number;
  purchase_order_id: number;
  task_id: number;
};
const paymentTaskComments = (props: Props): Promise<PaymentTaskComment[]> => {
  return axios.get(
    `/api/workspaces/${props.identifier}/teams/${props.team_id}/purchase_orders/${props.purchase_order_id}/payment_tasks/${props.task_id}/payment_task_comments`
  );
};

export const usePaymentTaskComments = (props: Props) => {
  return useQuery({
    queryKey: queryKey(props),
    queryFn: () => paymentTaskComments(props),
  });
};

export const usePaymentTaskCommentsInvalidate = (props: Props) => {
  const invalidate = () => {
    queryClient.invalidateQueries({ queryKey: queryKey(props) });
  };

  return { invalidate };
};

const queryKey = (props: Props) => {
  return [
    'workspaces',
    props.identifier,
    'teams',
    props.team_id,
    'purchase_orders',
    props.purchase_order_id,
    'payment_tasks',
    props.task_id,
    'payment_task_comments',
  ];
};
